<template>  
  <div class="full-width-panel">
    <div class="card card-body shadow m-0.5">
      <div class="full-width-summary">
        <div class="row">  
          <div class="col-md-3"><h3 class="h6 d-inline me-1">Create by:</h3> {{display.createdBy}}</div>
          <div class="col-md-3"><h3 class="h6 d-inline me-1">Created At:</h3> {{createdDate}}</div> 
        </div>
        <div class="d-flex">
          <div class="flex-fill full-width-textbox">
            <h3 class="h6">Notes</h3>
            {{display.notes}}
          </div>
          <div class="flex-fill full-width-textbox">
            <h3 class="h6">Comments</h3>
            {{display.comments}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
  data: function () {
    return {
      createdDate: ''
    }
  },
  beforeMount(){
    this.display = this.params.data;
    this.createdDate = moment(this.display.createdDate).format("MM/DD/YYYY")
  }
})
</script>